/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ProspectStage {
  to_draft = 'to_draft',
  to_send = 'to_send',
  in_progress = 'in_progress',
  contacted = 'contacted',
  replied = 'replied',
  excluded = 'excluded'
}
